document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-3)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('.JS-detail-3-photo-slider');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail3 = new Swiper(swiperSelector, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            lazy:  {
                loadPrevNext: true
            },
            slidesPerView: 1,
            spaceBetween: 0,
            centerInsufficientSlides: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                980: {
                    slidesPerView: 4,
                    spaceBetween: 10
                }
            }
        });
    }());
});